import { AnimationBuilder, animate, style } from '@angular/animations';
import { DOCUMENT, Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';

@Injectable()
export class UiHelperService {
    private document = inject<Document>(DOCUMENT);
    private animationBuilder = inject(AnimationBuilder);

    private renderer: Renderer2;

    constructor() {
        const rendererFactory = inject(RendererFactory2);

        this.renderer = rendererFactory.createRenderer(null, null);
    }

    addBodyClass(className: string): void {
        this.renderer.addClass(this.document.body, className);
    }

    hideSplashScreen(): void {
        const splashScreenElem = this.document.body.querySelector('#splash-screen');

        if (!splashScreenElem) {
            return;
        }

        const player = this.animationBuilder
            .build([
                style({ opacity: '1' }),
                animate(
                    '400ms ease',
                    style({
                        opacity: '0',
                        zIndex: '-10',
                    }),
                ),
            ])
            .create(splashScreenElem);

        player.onDone(() => splashScreenElem.remove());
        player.play();
    }
}
